<template>
    <jet-dialog-modal ref="modal" :show="show_modal" maxWidth="lg" @close="show_modal = false">
        <template v-slot:title>
            <div class="text-gray-700">Upgrade ✨</div>
        </template>
        <template v-slot:content>
            <div class="text-gray-600" v-if="$page.props.canManagePlan">{{ message_admin }}</div>
            <div class="text-gray-600" v-else>{{ message_agent }}</div>
        </template>
        <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex">
                    <jet-secondary-button @click.prevent="show_modal = false">
                        Later
                    </jet-secondary-button>
                </div>
                <div class="flex" v-if="$page.props.canManagePlan">
                    <jet-button @click.prevent="gotoSubscription">
                        Upgrade my plan
                    </jet-button>
                </div>
                <div class="flex" v-else>
                    <jet-button-link :link="mailtoOwnerLink">
                        Ask for an upgrade
                    </jet-button-link>
                </div>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetButtonLink from '@/Jetstream/ButtonLink'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'

export default {

    props: ['message_admin','message_agent','issue'],

    components: {
        JetDialogModal, JetButton, JetSecondaryButton, JetButtonLink
    },

    data() {
        return {
            show_modal: false,

        }
    },

    mounted: function() {
        //console.log("issue:",this.issue)
    },

    methods: {
        open: function() {
           this.show_modal = true
        },
        close: function() {
            this.show_modal = false
        },
        gotoSubscription: function() {
            this.$inertia.visit(route('subscription.index'));

        }
    },
    computed: {
        mailtoOwnerLink() {
            console.log(this.issue)
            let domain = this.$page.props.app_url.split('.').slice(-2).join('.')
            let name = this.$page.props.app_name
            if (this.issue == 'blur') {

                return 'mailto:'+this.$page.props.team_owner_email+'?subject='+name+' Blur sensitive data feature is  not accessible - please upgrade&body=Enable '+name+' blur sensitive data.%0D%0A %0D%0A Unlock account by visiting https://app.'+domain+'/subscription and upgrade. %0D%0A %0D%0A --- %0D%0A%0D%0A %0D%0A '
            }
            if (this.issue == 'autodelete') {
                return 'mailto:'+this.$page.props.team_owner_email+'?subject='+name+' auto-deletion is not accessible - please upgrade&body=Enable '+name+' auto-delete feature.%0D%0A %0D%0A Unlock account by visiting https://app.'+domain+'/subscription and upgrade. %0D%0A %0D%0A --- %0D%0A%0D%0A %0D%0A '
            }
            return 'mailto:'+this.$page.props.team_owner_email+'?subject='+name+' recordings not accessible - please upgrade&body=Some recordings are not accessible.%0D%0A %0D%0A Unlock account by visiting https://app.'+domain+'/subscription and upgrade. %0D%0A %0D%0A --- %0D%0A%0D%0A %0D%0A '

        }
    }
}

</script>

